// const BASE_URL = "http://localhost:3002";
// const BASE_URL = "https://api.youtubepremium.trangotechdevs.com";
const BASE_URL = "https://api.myfanly.com";

const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "7b3d5b1e-94c3-4e68-93f0-29f9ad4c8a79";

export { API_URL, BASE_URL, INITIAL_TOKEN };
